module.exports = __webpack_public_path__ + "media/packs/images/state/small/deal-abfaf3f47d89c8738ca6633c2b9e35e7.svg";